import { ResponsiveTableRow } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import TreeChangesTableMetadataColumn from './TreeChangesTableMetadataColumn'
import TreeChangesTableIdsColumn from './TreeChangesTableIdsColumn'
import TreeChangesTableDetailsColumn from './TreeChangesTableDetailsColumn'

export default function TreeChangesTable({ treeContributionsData }) {
  const { t } = useTranslation()
  const personIdFields = [
    'personId',
    'person1Id',
    'person2Id',
    'spouse1Id',
    'spouse2Id',
    'parent1Id',
    'parent2Id',
    'childId',
  ]
  const metadataFields = ['modified', 'type', 'contributorId']
  const relationshipIdFields = ['coupleId', 'parentChildId', 'associationId']

  return (
    <DmcResponsiveTable
      id="treeChangesTable"
      gutters="nano"
      totalColumnCount={3}
      atSizeColumns={{
        default: {
          labels: [
            t('person.metadata', 'Metadata'),
            `${t('person', 'Person')}/${t('relationshipIds', 'Relationship IDs')}`,
            t('details', 'Details'),
          ],
          columnWidths: [4, 4, 4],
          combinationRules: [['column1'], ['column2'], ['column3']],
        },
      }}
    >
      {treeContributionsData.tfUserContributions.contributions.map((contribution) => {
        return (
          <ResponsiveTableRow
            key={`${contribution.type}_${contribution.modified}`}
            column1={
              <TreeChangesTableMetadataColumn
                treeContributionsData={treeContributionsData}
                contribution={contribution}
              />
            }
            column2={
              <TreeChangesTableIdsColumn
                treeContributionsData={treeContributionsData}
                contribution={contribution}
                personIdFields={personIdFields}
                relationshipIdFields={relationshipIdFields}
              />
            }
            column3={
              <TreeChangesTableDetailsColumn
                contribution={contribution}
                personIdFields={personIdFields}
                relationshipIdFields={relationshipIdFields}
                metadataFields={metadataFields}
              />
            }
          />
        )
      })}
    </DmcResponsiveTable>
  )
}
